import { DimensionedNumberDisplay } from "common/components/DimensionedNumberDisplay";
import { directionToLocaleString } from "common/utils/enumTranslations";
import { NewJobsFormState } from "../FormState";
import { StackedDetail } from "../StackedDetail";
import { useFormikContext } from "formik";
import { useSelf } from "portal/state/store";
import { useTranslation } from "react-i18next";
import React from "react";

export const GroundPrepConfirmDetailsSection: React.FC = () => {
  const { values } = useFormikContext<NewJobsFormState>();
  const { t } = useTranslation();
  const { measurementSystem } = useSelf();

  let headlandsDesc: string;

  if (values.groundPrep.workHeadlandsWhen === "none") {
    headlandsDesc = t(
      "views.autotractor.jobCreation.step3ConfigurePreview.groundPrep.workHeadlandsNone"
    );
  } else if (values.groundPrep.workHeadlandsWhen === "before") {
    headlandsDesc = t(
      "views.autotractor.jobCreation.step3ConfigurePreview.groundPrep.workHeadlandsBefore"
    );
  } else {
    headlandsDesc = t(
      "views.autotractor.jobCreation.step3ConfigurePreview.groundPrep.workHeadlandsAfter"
    );
  }

  return (
    <>
      <div className="grid grid-flow-row grid-cols-4 grid-rows-[min-content]">
        <StackedDetail labelI18nKey="models.autotractor.jobType">
          {t("models.autotractor.jobTypes.groundPrep")}
        </StackedDetail>
      </div>
      <hr className="w-full" />
      <div className="grid grid-flow-row grid-cols-4 grid-rows-[min-content]">
        <StackedDetail labelI18nKey="models.pathPlanning.rowHeading">
          {values.groundPrep.rowHeadingMode === "planting" ? (
            t(
              "views.autotractor.jobCreation.step4Confirm.rowHeadingPlantingHeading",
              { offset: values.groundPrep.rowHeadingOffset }
            )
          ) : (
            <DimensionedNumberDisplay
              storedValue={values.groundPrep.rowHeadingOffset}
              storedUnit="deg"
              displayUnits={{ imperial: "deg", metric: "deg" }}
              localSystem={measurementSystem}
            />
          )}
        </StackedDetail>
        <StackedDetail labelI18nKey="views.autotractor.jobCreation.step3ConfigurePreview.groundPrep.workingOverlap">
          <DimensionedNumberDisplay
            storedValue={values.groundPrep.workingOverlapM}
            storedUnit="m"
            displayUnits={{ imperial: "ft", metric: "m" }}
            localSystem={measurementSystem}
          />
        </StackedDetail>
        <StackedDetail labelI18nKey="models.pathPlanning.turnDirection">
          {directionToLocaleString(t, values.groundPrep.turnDirection)}
        </StackedDetail>
        <StackedDetail labelI18nKey="views.autotractor.jobCreation.step3ConfigurePreview.groundPrep.workHeadlandsWhen">
          {headlandsDesc}
        </StackedDetail>
      </div>
    </>
  );
};
